"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppImagePreview = exports.AppPreview = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = tslib_1.__importStar(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
const StyledWrapper = styled_components_1.default.div `
  position: relative;
  display: flex;
  width: 100%;
  flex-flow: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  margin-bottom: ${({ theme, isEmbedded }) => isEmbedded ? 0 : ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
  border-radius: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Border.Radius.Large)}`};
`;
const StyledPromptContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};

  textarea {
    padding-bottom: ${({ theme }) => theme.Button.Size.XLarge + theme.Spacing.Size.Medium}px;
    min-height: ${({ type }) => (type === 'image' ? 'fit-content' : '450px')};
  }
`;
const StyledButtonWrapper = styled_components_1.default.div `
  display: flex;
  flex: 1;

  ${({ type }) => type === 'text' &&
    (0, styled_components_1.css) `
      position: absolute;
      width: calc(100% - ${({ theme }) => theme.Spacing.Size.Small * 2}px);
      padding-top: ${({ theme }) => theme.Spacing.Size.XSmall}px;
      padding-bottom: ${({ theme }) => theme.Spacing.Size.Small}px;
      bottom: 1px;
      left: ${({ theme }) => theme.Spacing.Size.Small}px;
      background-color: ${({ theme }) => theme.Color.Neutrals.Paper};
    `}
`;
const StyledImageWrapper = styled_components_1.default.a `
  display: block;
  cursor: pointer;
`;
function AppPreview({ labels, title, type, isEmbedded = false, status, result, children, allowRegenerate, onClick, onChangeView, }) {
    const [prompt, setPrompt] = (0, react_1.useState)(result);
    const onChangeHandler = (event) => {
        const value = event.target.value;
        setPrompt(value);
    };
    return ((0, jsx_runtime_1.jsxs)(StyledWrapper, { isEmbedded: isEmbedded, children: [title && status !== 'error' && ((0, jsx_runtime_1.jsxs)(StyledPromptContainer, { type: type, children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.TextArea, { name: "ai-answer", resize: 'none', defaultValue: title, disabled: type === 'image', onChange: onChangeHandler }), type === 'image' && allowRegenerate && isEmbedded && ((0, jsx_runtime_1.jsx)(StyledButtonWrapper, { type: type, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: 'outline', onClick: () => onChangeView === null || onChangeView === void 0 ? void 0 : onChangeView(), icon: { name: 'edit---3' }, children: labels.editDetails || '' }) }))] })), title && status === 'error' && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Alert, { type: 'error', message: labels.errorMessage })), children, status !== 'error' && ((0, jsx_runtime_1.jsx)(StyledButtonWrapper, { type: type, children: (0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { variant: "primary", onClick: () => onClick(prompt), icon: { name: 'add-custom-list---16' }, children: labels.insertButton }) }))] }));
}
exports.AppPreview = AppPreview;
function AppImagePreview({ children, onClick, }) {
    return (0, jsx_runtime_1.jsx)(StyledImageWrapper, { onClick: onClick, children: children });
}
exports.AppImagePreview = AppImagePreview;
//# sourceMappingURL=AppPreview.js.map